import { useEffect, useState } from "react";
import { applyGlobalBranding } from "./applyGlobalBranding";
import {
  BrandConfig,
  getBrandConfigFromStorage,
  mapApiResponseToBrandConfig,
  saveBrandConfigToStorage,
  staticBrandConfig,
} from "./brandConfig";
import { useTheme } from "../middleware/ThemeContext";

type DynamicBrandProviderProps = {
  children: React.ReactNode;
};

export const DynamicBrandProvider: React.FC<DynamicBrandProviderProps> = ({ children }) => {
  const { theme } = useTheme();
  const [brandConfig, setBrandConfig] = useState<BrandConfig>(
    () => getBrandConfigFromStorage() || staticBrandConfig
  );

  useEffect(() => {
    let isMounted = true;

    const loadFromShellApi = async () => {
      try {
        const apiBase = process.env.REACT_APP_API_URL || "";
        const basePath = `${apiBase}/public/site`;
        const searchParams = new URLSearchParams(window.location.search);
        const domainFromQuery = searchParams.get("domain");
        const domain = domainFromQuery ? decodeURIComponent(domainFromQuery) : window.location.origin;
        const domainParams = new URLSearchParams({ domain });

        const response = await fetch(`${basePath}/shell?${domainParams.toString()}`);
        const shellJson = await response.json();
        
        if (!response.ok) {
          return;
        }

        const mapped = mapApiResponseToBrandConfig(shellJson);
        if (!isMounted || !mapped) {
          return;
        }

        setBrandConfig(mapped);
      } catch {
        // Keep local/static config on failure.
      }
    };

    loadFromShellApi();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    applyGlobalBranding(brandConfig, theme.name === "dark" ? "dark" : "light");
    saveBrandConfigToStorage(brandConfig);
  }, [brandConfig, theme.name]);

  return <>{children}</>;
};
